import { render, staticRenderFns } from "./pagination-table.vue?vue&type=template&id=bacd591e&"
import script from "./pagination-table.vue?vue&type=script&lang=js&"
export * from "./pagination-table.vue?vue&type=script&lang=js&"
import style0 from "./pagination-table.vue?vue&type=style&index=0&id=bacd591e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports